import React, { useState, useEffect, useCallback, useRef } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb, ConfigProvider, DatePicker } from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import { getVendorDetails, getVendorInventoryDetails, getVendorProducts } from "../../API  Functions/PurchaseFunctions";
import VendorTiles from "./VendorInfoTiles";
import TopProductsTable from "./PurchaseTables/AllProductsTable";
import BottomProductsTable from "./PurchaseTables/TopBottomProductsTable";
import dayjs from "dayjs";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import SelectBox from "../../components/CustomWidgets/SelectBox";
import moment from "moment";
import { debounce } from "@mui/material";
import TopBottomProductsTable from "./PurchaseTables/TopBottomProductsTable";
import AllProductsTable from "./PurchaseTables/AllProductsTable";
import axiosInstance from "../../AxiosInstance";
import i18next from "i18next";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
import PurchasePayment from "../../modals/purchasePaymentModal";
import VendorHighLowTiles from "./VendorHighLowTiles";
import { checkPermission } from "../../Utils/permissionHelper";

const { RangePicker } = DatePicker;

const formatDate = (date) => dayjs(date).format("YYYY-MM-DD");

const getStartOfWeek = () => {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 is Sunday, 1 is Monday, ..., 6 is Saturday
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - dayOfWeek);
  return startOfWeek.toISOString().split("T")[0];
};

const getStartOfMonth = () => {
  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  // Format the date as 'YYYY-MM-DD' without using toISOString to avoid timezone issues
  const year = startOfMonth.getFullYear();
  const month = String(startOfMonth.getMonth() + 1).padStart(2, "0"); // Ensure month is two digits
  const day = String(startOfMonth.getDate()).padStart(2, "0"); // Ensure day is two digits

  return `${year}-${month}-${day}`;
};

const getCurrentDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};



const VendorInfo = () => {
  const { t, i18n } = useTranslation();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [searchByShortCode, setSearchByShortCode] = useState(false);

  const [searchid, setSearchId] = useState(localStorage.getItem("searchid"));
  const [vendorData, setVendorData] = useState({});
  const [vendorInventoryData, setVendorInventoryData] = useState({});
  const [dateRange, setDateRange] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [vendorTableData, setVendorTableData] = useState({});
  const [selectedRange, setSelectedRange] = useState("thisMonth");
  const [startDate, setStartDate] = useState(getStartOfMonth());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [productData, setProductData] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [bottomProducts, setBottomProducts] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [vendorID, setVendorId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [popup, setpopup] = useState(false);
  const searchidRef = useRef(searchid);
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );


  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );

  const location = useLocation();
  const fromPage = location.state?.from;


  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  };


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");

    if (id) localStorage?.setItem("vendorId", id);

    const searchParam = id || localStorage.getItem("vendorId");
    setSearchId(searchParam);

    if (searchParam) {
      setLoading(true);
      getVendorInfo(searchParam);
      getVendorInventoryInfo(searchParam);
      fetchVendorProducts("", startDate, endDate, "all", searchParam, 10, 0);
    }
  }, []);

  const getVendorInfo = async (vendorId, start_date = "", end_date = "") => {
    setLoading(true);
    const data = await getVendorDetails(
      company_id,
      vendorId,
      start_date,
      end_date
    );
    setVendorData(data || {});
    setLoading(false);
  };

  const refreshVendorData = () => {
    getVendorInfo(searchid, startDate, endDate);
  };


  const getVendorInventoryInfo = async (vendorId) => {
    setLoading(true);

    const response = await getVendorInventoryDetails(company_id, vendorId);
    console.log("vendor inventory data", response);

    // Ensure 'data' exists and has the structure you're expecting
    if (response?.status_code === 200 && response?.data) {
      setVendorInventoryData(response.data);
    } else {
      setVendorInventoryData({
        low_on_inventory: 0,
        high_on_inventory: 0,
        out_of_stock: 0,
        healthy_inventory: 0,
      }); // fallback default in case of bad response
    }

    setLoading(false);
  };


  const fetchVendorProducts = async (
    search = "",
    start = "",
    end = "",
    filter = "all",
    searchParam,
    limit,
    offset
  ) => {
    // setTableLoading(true);
    try {
      let searchkey = searchByShortCode ? "" : search;
      let shortkey = searchByShortCode ? search : '';
      const result = await getVendorProducts(
        company_id,
        searchParam,
        searchkey,
        end,
        filter,
        search,
        limit,
        offset,
        shortkey
      );

      console.log('vendor products', result);

      setProductData(result || []);
      // setTopProducts(result|| []);
      // setBottomProducts(result || []);
    } catch (error) {
      console.error("Error fetching vendor products:", error);
    } finally {
      setTableLoading(false);
    }
  };



  useEffect(() => {
    searchidRef.current = searchid;
  }, [searchid]);

  const handleSearchChange = useCallback(
    debounce((value) => {
      const currentSearchId = searchidRef.current;

      setSearchQuery(value);
      setCurrentLimit(10)
      setCurrentOffset(0)
      fetchVendorProducts(value, startDate, endDate, activeTab, currentSearchId, 10, 0);
    }, 1000),
    [searchid]
  );

  const handleRangePickerChange = (dates) => {
    if (dates && dates.length === 2) {
      const [start, end] = dates;
      const formattedStart = dayjs(start).format("YYYY-MM-DD");
      const formattedEnd = dayjs(end).format("YYYY-MM-DD");
      setDateRange([formattedStart, formattedEnd]);

      getVendorInfo(searchid, formattedStart, formattedEnd, searchid);
    } else {
      setDateRange([]);
      getVendorInfo(searchid);
    }
  };


  const handleDateRangeChange = (range) => {
    const value = range.target.value;
    setSelectedRange(value);

    let start, end;
    if (value === "today") {
      start = getCurrentDate();
      end = getCurrentDate();
    } else if (value === "thisWeek") {
      start = getStartOfWeek();
      end = getCurrentDate();
    } else if (value === "thisMonth") {
      start = getStartOfMonth();
      end = getCurrentDate();
    } else {
      return;
    }

    setStartDate(start);
    setEndDate(end);
    setCurrentLimit(10)
    setCurrentOffset(0)
    fetchVendorProducts(searchQuery, start, end, activeTab, searchid, 10, 0);
  };

  const handleRangePickerChanges = (dates) => {
    if (dates) {
      const start = formatDate(dates[0]);
      const end = formatDate(dates[1]);

      setStartDate(start);
      setEndDate(end);
      setCurrentLimit(10)
      setCurrentOffset(0)
      fetchVendorProducts(searchQuery, start, end, activeTab, searchid, 10, 0);
    }
  };

  const disabledDate = (current) => {
    // Disable dates that are after today
    return current && current > moment().endOf("day");
  };


  // ⭐ UPDATED EXPORT FUNCTION WITH ACTIVE FILTERS
  const handleExport = async () => {
    let searchkey = searchByShortCode ? "" : searchQuery;
    let shortkey = searchByShortCode ? searchQuery : "";

    let payload = {
      lang: i18next.language === 'ar' ? 'ar_001' : 'en_US',
      company_id: company_id,
      vendor_id: Number(searchid),
      
      // 🔥 Match live filter parameter conditions from fetchVendorProducts
      search: searchkey,
      short_code: shortkey,
      filter: activeTab, // Synchronizes tab scopes (e.g., "all")
      
      // If your export backend tracks explicit dates like your data graphs do:
      start_date: startDate,
      end_date: endDate,
    };

    try {
      const response = await axiosInstance.post(
        URLS.DOWNLOAD_VENDOR_PRODUCTS_EXCEL,
        payload
      );
      
      console.log("handleExport", response?.data?.result);
      
      if (response?.data?.result?.status_code == 200) {
        // If your endpoint yields download links via properties like .file or .file_base64
        const fileData = response?.data?.result?.file || response?.data?.result?.file_base64;
        downloadFile(fileData);
      } else {
        toast.error(response?.data?.result?.status || t("Export failed"));
      }
    } catch (error) {
      console.error("Vendor products export failure:", error);
      toast.error(t("Something went wrong while exporting"));
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      // const timestamp = new Date()
      //   .toISOString()
      //   .replace(/[:.]/g, "-")
      //   .replace("T", "_")
      //   .slice(0, 19);
      const timestamp = moment().format('YYYY-MM-DD_HH.mm.ss'); // Using period for time

      const filename = `${t('vendor_products')}_${timestamp}.${fileExtension}`;
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };



  const handlePaymentClick = () => {
    // console.log("VADVSVDVSD", searchid);

    setVendorId(searchid);
    setIsModalVisible(true);
  };

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto bg-[#F6F7F9]">
        <Navbar heading="Vendor Details" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
          {/* {loading ? (
            <ShimmerLoader />
          ) : ( */}
          <>
            <div className="font-extrabold">
              <Breadcrumb
                separator={<DoubleRightOutlined />}
                items={[
                  {
                    title: (
                      <Link to={fromPage === "vendor_payment" ? routes.purchase.supplyPayment : routes.purchase.vendors}>
                        {fromPage === "vendor_payment" ? t("Vendor Invoices") : t("Vendor List")}
                      </Link>
                    ),
                    key: fromPage === "vendor_payment" ? "vendor_payment" : "all_vendors",
                  },
                  { title: t("Vendor Details") },
                ]}
                className="relative mt-3 font-semibold"
              />
              {/* <Breadcrumb
                separator={<DoubleRightOutlined />}
                items={[
                  {
                    title: (
                      <Link to={routes.purchase.vendors}>
                        {t("All Vendors")}
                      </Link>
                    ),
                    key: "all_vendors",
                  },
                  { title: t("Vendor Details") },
                ]}
                className="relative mt-3 font-semibold"
              /> */}
            </div>

            <div className="flex justify-end mt-4 me-4">
              <ConfigProvider direction={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                <RangePicker
                  className="range-picker-placeholder"
                  style={{ minWidth: 220, height: 40 }}
                  placeholder={[t("Start Date"), t("End Date")]}
                  onChange={handleRangePickerChange}
                  allowClear
                  value={
                    dateRange.length === 2
                      ? [dayjs(dateRange[0]), dayjs(dateRange[1])]
                      : null
                  }
                />
              </ConfigProvider>
            </div>

            <div className="bg-white mt-3 rounded-lg">
              <div className="flex flex-row md:flex-row items-end justify-between bg-white rounded-lg me-4  p-4">
                <div className="flex flex-col gap-2 ms-4 text-gray-800">
                  <h3 className="text-sm font-medium">{t("Vendor Name")}</h3>
                  <p>
                    <span className="text-xl font-semibold">
                      {vendorData?.vendor_name || "--"}
                    </span>
                  </p>
                </div>

                <div className="flex flex-row md:flex-row items-center gap-8">
                  {(vendorData?.balance_amount > 0) && (
                    <button
                      // onClick={() => handlePaymentClick()}
                      onClick={() => {
                        if (checkPermission("/purchase/vendors", isGinne)) {
                          handlePaymentClick();
                        }
                      }}
                      className={`font-semibold w-28 h-10 border rounded-lg bg-[#7EC242] text-white text-base flex justify-center items-center gap-2`}
                      type="submit"
                    >
                      <p className="">{t("Pay Now")}</p>
                    </button>
                  )}
                  <div className="flex flex-col gap-2 me-16 text-gray-800">
                    <h3 className="text-sm font-medium">
                      {/* {t("Balance Amount")} */}
                      {t("Balance Due")}
                    </h3>
                    <p>
                      <span className="text-xl font-semibold">
                        {"EGP"} {vendorData?.balance_amount?.toFixed(2) || "--"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <VendorHighLowTiles data={vendorInventoryData} />
              <VendorTiles data={vendorData} />
            </div>


            <div className="flex justify-between items-start me-4 nmt-2 gap-4">
            <div className="flex gap-x-2">
    <SearchBox
                placeholder={t("Search Products")}
                 searchResult={(values) => {
                // setquery(values);

                if (searchByShortCode) {
                  handleSearchChange(values);
                } else if (values.length >= 2 || values.length === 0) {
                  handleSearchChange(values);
                }
              }}
                // searchResult={handleSearchChange}
                
                // value={searchQuery}
              />
 <button
              type="button"
              onClick={() => {
                if (searchByShortCode) {
                  handleSearchChange("");
                }
                setSearchByShortCode(!searchByShortCode);
              }}
              className={`h-[40px] px-2 rounded-md border text-sm whitespace-nowrap
    ${
      searchByShortCode
        ? "bg-blue-100 border-primaryBlue text-primaryBlue"
        : "bg-white border-gray-300 text-gray-700"
    }`}
            >
              {t("Search Code")}
            </button>
            </div>
          
              {activeTab === "all" && (
                <button
                  className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                  // onClick={() => handleExport()}
                  // onClick={() => {
                  //   if (checkPermission("/purchase/vendors", isGinne)) {
                  //     handleExport();
                  //   }
                  // }}

                  onClick={() => {
                    // If allStores is true, directly call handleExport
                    if (allStores) {
                      handleExport();
                    } else {
                      // Otherwise, check permission before calling handleExport
                      if (checkPermission("/purchase/vendors", isGinne)) {
                        handleExport();
                      }
                    }
                  }}
                >
                  <DownloadOutlined
                    style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                  />

                  <span>{t("Download in Excel")}</span>
                </button>
              )}

              {/* <div className={`flex`}>
                  <SelectBox
                    componentWidth={"w-56"}
                    value={selectedRange}
                    options={[
                      { value: "today", label: t("Today") },
                      { value: "thisWeek", label: t("This Week") },
                      { value: "thisMonth", label: t("This Month") },
                      { value: "custom", label: t("Custom Range") },
                    ]}
                    onChange={handleDateRangeChange}
                    placeholder={t("select_date_range")}
                  />
                  {selectedRange === "custom" && (
                    <ConfigProvider direction={i18n.language == 'ar' ? "rtl" : 'ltr'}>
                      <RangePicker
                        className=" h-10 mx-2 range-picker-placeholder"
                        style={{ minWidth: 220 }}
                        onChange={handleRangePickerChanges}
                        placeholder={[t("Start Date"), t("End Date")]}
                        disabledDate={disabledDate}
                      />
                    </ConfigProvider>
                  )}
                </div> */}
            </div>

            <div className="mt-6 bg-white rounded-lg">
              <div className="flex items-center justify-between px-4 pt-4 border-b">
                <div className="flex gap-6 font-semibold text-[#999999] text-base">
                  <button
                    onClick={() => {
                      setActiveTab("all");
                      setSearchQuery("");
                      setSelectedRange("thisMonth");
                      setStartDate(getStartOfMonth());
                      setEndDate(getCurrentDate());
                      setCurrentLimit(10)
                      setCurrentOffset(0)
                      fetchVendorProducts("", getStartOfMonth(), getCurrentDate(), "all", searchid, 10, 0);
                    }}
                    className={`pb-2 ${activeTab === "all" ? "text-[#272728] border-b-4 border-[#78CFEC]" : ""}`}
                  >
                    {t("all_products")}
                  </button>
                  <button
                    onClick={() => {
                      setActiveTab("top");
                      setSearchQuery("");
                      setSelectedRange("thisMonth");
                      setStartDate(getStartOfMonth());
                      setEndDate(getCurrentDate());
                      setCurrentLimit(10)
                      setCurrentOffset(0)
                      fetchVendorProducts("", getStartOfMonth(), getCurrentDate(), "top", searchid, 10, 0);
                    }}
                    className={`pb-2 ${activeTab === "top" ? "text-[#272728] border-b-4 border-[#78CFEC]" : ""}`}
                  >
                    {t("Top 5 Products")}
                  </button>
                  <button
                    onClick={() => {
                      setActiveTab("bottom");
                      setSearchQuery("");
                      setSelectedRange("thisMonth");
                      setStartDate(getStartOfMonth());
                      setEndDate(getCurrentDate());
                      setCurrentLimit(10)
                      setCurrentOffset(0)
                      fetchVendorProducts("", getStartOfMonth(), getCurrentDate(), "bottom", searchid, 10, 0);
                    }}
                    className={`pb-2 ${activeTab === "bottom" ? "text-[#272728] border-b-4 border-[#78CFEC]" : ""}`}
                  >
                    {t("Bottom 5 Products")}
                  </button>
                </div>
              </div>
              <div className=" mt-3 pt-4 mb-5">
                {tableLoading ? (
                  <ShimmerLoader />
                ) : activeTab === "all" ? (
                  <AllProductsTable
                    tabledata={productData}
                    pagination={(values) => {

                      setCurrentLimit(values.limit);
                      setCurrentOffset(values.offset);
                      fetchVendorProducts("", startDate, endDate, activeTab, searchid, values.limit, values.offset);
                    }} />
                ) : activeTab === "top" ? (
                  <TopBottomProductsTable tabledata={productData} />
                ) : (
                  <TopBottomProductsTable tabledata={productData} />
                )}
              </div>
            </div>
          </>
          {/* )} */}
        </div>
      </div>

      {isModalVisible && (
        <PurchasePayment
          isOpen={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          vendor_id={vendorID}
          page={"allVendors"}
          // due_amount={selectedDueAmount}
          Popup={() => {
            setpopup(true);
          }}
          onPaymentSuccess={refreshVendorData}
        />
      )}
    </>
  );
};

export default VendorInfo;
